import { render } from "./CollectNumbers.vue?vue&type=template&id=6ee244d5"
import script from "./CollectNumbers.vue?vue&type=script&lang=js"
export * from "./CollectNumbers.vue?vue&type=script&lang=js"

import "./CollectNumbers.vue?vue&type=style&index=0&id=6ee244d5&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__